var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-wrapper1 bhxc-bg",
      class: { hideSidebar: !_vm.sidebar.opened }
    },
    [
      _c(
        "div",
        { staticStyle: { height: "65px" } },
        [_c("sidebar", { staticClass: "sidebar-container" }), _c("navbar")],
        1
      ),
      _c("div", { staticClass: "main-container" }, [_c("app-main")], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }